import React, { Dispatch, SetStateAction } from 'react';

import { InputAdornment, TableRow, TextField, Typography } from '@material-ui/core';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import { NoBorderCell } from 'components/common/table/TableStyle';
import { BoldText } from '../ModalContent.styled';
import { CouponFormField } from 'types/member';
import { MAX_COUPON_AMOUNT } from 'constants/member/connect';
import { toMantissaWithDollarSign } from 'modules/utils/number';

interface Props {
  couponAmount: string;
  onChangeValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Amount = ({ couponAmount, onChangeValue }: Props) => {
  return (
    <TableRow>
      <NoBorderCell>
        <BoldText>Amount</BoldText>
      </NoBorderCell>
      <NoBorderCell
        style={{ display: 'flex', alignItems: 'center', gap: '8px', alignContent: 'left' }}
      >
        <TextField
          name={CouponFormField.AMOUNT}
          type={'number'}
          size={'small'}
          variant={'outlined'}
          placeholder={'0.00'}
          value={couponAmount}
          onChange={onChangeValue}
          inputProps={{ max: MAX_COUPON_AMOUNT }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MonetizationOnIcon fontSize={'small'} />
              </InputAdornment>
            ),
          }}
        />
        <Typography variant="body2" style={{ color: '#999', fontSize: '12px' }}>
          Up to {toMantissaWithDollarSign(MAX_COUPON_AMOUNT, 0)} off
        </Typography>
      </NoBorderCell>
    </TableRow>
  );
};

export default Amount;
